<template>
  <Dialog :visible="true" modal :style="{ width: '46rem' }" :breakpoints="{ '640px': '95vw' }" header="تعديل الوصول السريع" @update:visible="$emit('close')">
    <div class="ds-field-grid">
      <div class="form-field">
        <label class="field-label">تسمية القسم (للمسجلين)</label>
        <input type="text" class="form-control" v-model="form.auth_label" />
      </div>
      <div class="form-field">
        <label class="field-label">عنوان القسم (للمسجلين)</label>
        <input type="text" class="form-control" v-model="form.auth_title" />
      </div>
    </div>
    <div class="form-field mt-3">
      <label class="field-label">بطاقات المسجلين</label>
      <div v-for="(card, i) in form.auth_cards" :key="'a' + i" class="hb-card-row">
        <input type="text" class="form-control hb-col-sm" v-model="card.icon" placeholder="رمز" />
        <input type="text" class="form-control" v-model="card.title" placeholder="العنوان" />
        <input type="text" class="form-control" v-model="card.desc" placeholder="الوصف" />
        <input type="text" class="form-control" dir="ltr" v-model="card.link" placeholder="/contents" />
        <select class="form-select hb-col-md" v-model="card.accent">
          <option value="ac-lessons">ac-lessons</option>
          <option value="ac-exams">ac-exams</option>
          <option value="ac-hw">ac-hw</option>
          <option value="ac-results">ac-results</option>
        </select>
      </div>
    </div>

    <hr class="my-3" />

    <div class="ds-field-grid">
      <div class="form-field">
        <label class="field-label">تسمية القسم (للزوار)</label>
        <input type="text" class="form-control" v-model="form.guest_label" />
      </div>
      <div class="form-field">
        <label class="field-label">عنوان القسم (للزوار)</label>
        <input type="text" class="form-control" v-model="form.guest_title" />
      </div>
    </div>
    <div class="form-field mt-3">
      <label class="field-label">بطاقات الزوار</label>
      <div v-for="(card, i) in form.guest_cards" :key="'g' + i" class="hb-card-row hb-card-row--nolink">
        <input type="text" class="form-control hb-col-sm" v-model="card.icon" placeholder="رمز" />
        <input type="text" class="form-control" v-model="card.title" placeholder="العنوان" />
        <input type="text" class="form-control" v-model="card.desc" placeholder="الوصف" />
        <select class="form-select hb-col-md" v-model="card.accent">
          <option value="fc-purple">fc-purple</option>
          <option value="fc-blue">fc-blue</option>
          <option value="fc-green">fc-green</option>
          <option value="fc-orange">fc-orange</option>
        </select>
      </div>
    </div>

    <div class="form-field mt-2 hb-visibility">
      <label class="field-label">الحالة</label>
      <InputSwitch v-model="form.is_active" />
    </div>

    <template #footer>
      <button class="btn-cancel" @click="$emit('close')">إلغاء</button>
      <button class="ds-btn ds-btn--primary" :disabled="store.saving" @click="save">
        <i class="pi pi-check"></i> {{ store.saving ? 'جارٍ الحفظ...' : 'حفظ' }}
      </button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2';
import { useHomepageSectionStore } from '@/stores/useHomepageSectionStore.js';

function cloneCards(cards, withLink) {
  return (cards?.length ? cards : [{}, {}, {}, {}]).map((c) => ({
    icon: c.icon || '', title: c.title || '', desc: c.desc || '',
    ...(withLink ? { link: c.link || '' } : {}),
    accent: c.accent || '',
  }));
}

export default {
  name: 'QuickAccessEditor',
  components: { Dialog, InputSwitch },
  props: { section: { type: Object, required: true } },
  emits: ['close', 'saved'],
  data() {
    const s = this.section.settings || {};
    return {
      form: {
        auth_label: s.auth_label || '',
        auth_title: s.auth_title || '',
        guest_label: s.guest_label || '',
        guest_title: s.guest_title || '',
        auth_cards: cloneCards(s.auth_cards, true),
        guest_cards: cloneCards(s.guest_cards, false),
        is_active: !!this.section.is_active,
      },
    };
  },
  computed: {
    store() { return useHomepageSectionStore(); },
  },
  methods: {
    async save() {
      try {
        await this.store.updateSection(this.section.id, {
          settings: {
            auth_label: this.form.auth_label,
            auth_title: this.form.auth_title,
            guest_label: this.form.guest_label,
            guest_title: this.form.guest_title,
            auth_cards: this.form.auth_cards,
            guest_cards: this.form.guest_cards,
          },
          is_active: this.form.is_active,
        });
        Swal.fire({ icon: 'success', title: 'تم الحفظ', timer: 1400, showConfirmButton: false });
        this.$emit('saved');
      } catch (e) {
        Swal.fire({ icon: 'error', title: e?.response?.data?.message || 'حدث خطأ', timer: 2500, showConfirmButton: false });
      }
    },
  },
};
</script>

<style scoped>
.hb-visibility { display: flex; align-items: center; justify-content: space-between; }
.hb-card-row { display: grid; grid-template-columns: 60px 1fr 1fr 100px 120px; gap: 0.5rem; margin-bottom: 0.5rem; }
.hb-card-row--nolink { grid-template-columns: 60px 1fr 1fr 120px; }
.hb-col-sm { max-width: 90px; }
.hb-col-md { max-width: 140px; }
</style>
